import { createButton } from 'react-simple-wysiwyg';

import { RightIndent01Icon } from '@/assets/icons/RightIndent01Icon';

export default createButton('Right Indent', <RightIndent01Icon />, 'outdent');
